module.exports = __webpack_public_path__ + "static/IntelligentAnalize-a06c007e62ae40c3468ea62395f03bb8.png";